import React, {FC} from 'react';
import styled from 'styled-components';

import {BoxedIcon} from '../../../../libs/shared/ui/src/components/icon/boxedIcon';
import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';
import {SheetEmoji} from '../../../components/common/emoji/sheetEmoji';
import {getEmojiHighlight} from '../../../helpers/models/highlightHelpers';
import {HighlightTypesEnum} from '../../../models/api/highlightBaseModel';
import {TagModel} from '../../../models/api/tagModel';

/*
 * Props.
 */

interface SettingsSearchTagProps {
  tag: TagModel;
}

/*
 * Style.
 */

const StyledBoxedEmoji = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  width: 32px;
  height: 32px;
  box-sizing: border-box;
  background-color: ${(p) => p.theme.foreground};
  border: 1px ${(p) => p.theme.alphas.gray10} solid;
`;

/*
 * Component.
 */

export const SettingsSearchTagIcon: FC<SettingsSearchTagProps> = (props) => {
  const theme = useUserTheme();
  const {tag} = props;

  if (tag.type === HighlightTypesEnum.EMOJI) {
    const definition = getEmojiHighlight(tag);
    if (definition) {
      return (
        <StyledBoxedEmoji>
          <SheetEmoji emoji={definition.emoji} skinTone={definition.skinTone} size={20} />
        </StyledBoxedEmoji>
      );
    }
  }

  const tagColor =
    tag.type === HighlightTypesEnum.COLOR ? theme.palette[tag.highlightColor].shade40 : theme.greys.shade70;

  return (
    <BoxedIcon
      name="tagFilledSmall"
      backgroundColor={theme.foreground}
      color={tagColor}
      borderColor={theme.alphas.gray10}
      borderStyle="solid"
      size={VisualSizesEnum.SMALL}
    />
  );
};
